function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDiscussionRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 2a2 2 0 012 2v14a2 2 0 01-2 2h-2V10c0-2.206-1.795-4-4-4H8V4a2 2 0 012-2h18z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16h12v-2H7v2zm0 5h6v-2H7v2zM22 8H4a2 2 0 00-2 2v14a2 2 0 002 2h5l4 4 4-4h5a2 2 0 002-2V10a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconDiscussionRexFilled;